(function () {
  function activate(section, index) {
    var tabs = section.querySelectorAll('.et-lp-skin-phases__tab');
    var panels = section.querySelectorAll('.et-lp-skin-phases__panel');

    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-et-tab') === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-et-panel') === index);
    });
  }

  function initSection(section) {
    if (section.dataset.etTabsReady) return;
    section.dataset.etTabsReady = 'true';

    var tabs = section.querySelectorAll('.et-lp-skin-phases__tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(section, tab.getAttribute('data-et-tab'));
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.et-lp-skin-phases').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
